import { useQuery } from "@tanstack/react-query";

import type { Category } from "@/shared/domains";
import { productsQueriesStore } from "../api";

export const usePatientProductsByCategory = (categoryId?: Category["id"]) => {
  return useQuery(
    productsQueriesStore.products.patient._ctx.products(categoryId),
  );
};
